import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { services } from '../data/mockData';

const Services = () => {
  return (
    <div>
      {/* Hero Section */}
      <section style={{ 
        background: 'var(--bg-secondary)',
        padding: '80px 0',
        borderBottom: '1px solid var(--border-light)'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Our Services
          </h1>
          <p className="body-large" style={{ 
            color: 'var(--text-secondary)',
            maxWidth: '700px'
          }}>
            Comprehensive dental care solutions combining advanced technology with 
            painless procedures and compassionate service
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section-padding">
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px'
          }}>
            {services.map((service) => (
              <div 
                key={service.id}
                style={{
                  background: 'var(--bg-primary)',
                  borderRadius: '0px',
                  overflow: 'hidden',
                  border: '1px solid var(--border-light)',
                  transition: 'all 0.2s ease'
                }}
                className="service-card"
              >
                <img 
                  src={service.image}
                  alt={service.title}
                  style={{
                    width: '100%',
                    height: '220px',
                    objectFit: 'cover'
                  }}
                />
                <div style={{ padding: '32px' }}>
                  <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                    {service.title}
                  </h3>
                  <p className="body-regular" style={{ 
                    marginBottom: '24px',
                    color: 'var(--text-secondary)'
                  }}>
                    {service.shortDesc}
                  </p>
                  
                  {service.fullDesc ? (
                    <Link 
                      to={`/services/${service.id}`}
                      className="btn-secondary"
                      style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                    >
                      Learn More
                      <ArrowRight size={16} />
                    </Link>
                  ) : (
                    <Link 
                      to="/book-appointment"
                      className="btn-secondary"
                      style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                    >
                      Book Appointment
                      <ArrowRight size={16} />
                    </Link>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ background: 'var(--bg-secondary)' }} className="section-padding">
        <div className="container">
          <div style={{
            textAlign: 'center',
            maxWidth: '700px',
            margin: '0 auto'
          }}>
            <h2 className="hero-medium" style={{ marginBottom: '16px' }}>
              Not Sure Which Service You Need?
            </h2>
            <p className="body-large" style={{ 
              marginBottom: '32px',
              color: 'var(--text-secondary)'
            }}>
              Schedule a consultation and let our experts guide you to the best treatment for your needs
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/book-appointment" className="btn-primary">
                Book Consultation
              </Link>
              <Link to="/contact" className="btn-secondary">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .service-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
        }
      `}</style>
    </div>
  );
};

export default Services;
